import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { UserLoginData } from 'src/api/modules/auth';

export const useAuthStore = defineStore('auth', () => {
  // 初始化時嘗試從 localStorage 撈取資料
  const token = ref<string | null>(localStorage.getItem('token') || null);

  // 使用嚴格型別保護使用者資訊
  const userInfoStr = localStorage.getItem('userInfo');
  const userInfo = ref<UserLoginData | null>(userInfoStr ? JSON.parse(userInfoStr) : null);

  const setAuthData = (newToken: string, data: UserLoginData) => {
    token.value = newToken;
    userInfo.value = data;
    localStorage.setItem('token', newToken);
    localStorage.setItem('userInfo', JSON.stringify(data));
  };

  const logout = () => {
    token.value = null;
    userInfo.value = null;
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
  };

  const isLoggedIn = () => !!token.value;

  // 🚀 權限檢核方法 (配合你後端的 1000:read 格式)
  const hasPermission = (permission: string) => {
    return userInfo.value?.permissions?.includes(permission) || false;
  };

  return {
    token,
    userInfo,
    setAuthData,
    logout,
    isLoggedIn,
    hasPermission,
  };
});
